<script>
    //import ProjectSelect from '../Components/ProjectSelect.svelte';
    import DefaultFilter from './DefaultFilter.svelte';
    let statistic      = undefined;
    let path           = undefined;
    let statistics     = []
    let filter         = {}
    let filterExpanded = false;
    import {apiUrl} from '../config.svelte';
    import {Button,Table,Card,CardBody,CardHeader,Input} from 'sveltestrap';
    import {onMount,onDestroy} from 'svelte';
    let loading=false;
    let data    = []
    let columns = []
    let columns_schema = []
    let sum_column = undefined
    let sum_row = []
    let executed=undefined
    let dataSorted=undefined;

    function isEmpty(obj) {
		return Object.keys(obj).length === 0;
    }

    function sort(field){
        if(dataSorted==field){
            dataSorted=undefined;
            let srtFunc=(a,b)=>{
                if ( a[field].value < b[field].value ){
                    return 1;
                }
                if ( a[field].value > b[field].value ){
                    return -1;
                }
                return 0;
            }
            data.sort(srtFunc)
        }else{
            dataSorted=field;
            let srtFunc=(a,b)=>{
                if ( a[field].value < b[field].value ){
                    return -1;
                }
                if ( a[field].value > b[field].value ){
                    return 1;
                }
                return 0;
            }
            data.sort(srtFunc)
        }
        data=data
    }

    onMount(()=>{
        fetch(apiUrl+"employ",{
                method:"POST",
                credentials:'include',
                body:JSON.stringify({method:"statistics"}),
                cors:'no-cors'
            })
            .then(x=>x.json())
            .then(x=>{
                if(x.result){
                    
                    statistics     = x.data;
                    statistic      = undefined
                    filterExpanded = false;
                }else{
                    filterExpanded = false;
                    statistics     = []
                    statistic      = undefined
                }
            })
            .catch(()=>{
                filterExpanded = false;
                statistics     = []
                statistic      = undefined
            })
    })

    

    function execStat(){
        executed = statistic
        columns            = []
        columns_schema     = []
        sum_column         = undefined
        data               = []
        sum_row            = undefined
        filterExpanded     = false;
        loading            = true;
        fetch(apiUrl+"employ",{
            method : "POST",
            body   : JSON.stringify({method:statistic,filter:filter}),
            cors   : 'no-cors',
            credentials:'include',
        })
        .then(x => x.json())
        .then(x => {
            loading = false;
            if(x.result){
                if(statistic=="нагрузка суперов new"){
                    loading=false;
                    data    = x.data;
                    columns = x.columns
                    sum_row = undefined
                }else{
                    data       = x.data;

                    let columns_height=1
                    x.columns.forEach(c=>{
                        if(c.length>columns_height)
                            columns_height=c.length;
                    })
                    let last_columns=[]
                    
                    for(let i=0;i<columns_height;i++){
                        last_columns.push(undefined)
                        columns_schema.push([])
                    }
                    x.columns.forEach(c=>{
                        let dimx=0;
                        let lcol = c.join('|');
                        c.forEach(sc=>{
                            if(last_columns[dimx]==sc){
                                columns_schema[dimx][columns_schema[dimx].length-1].colspan++;
                            }else{
                                if(dimx==columns_height-1){
                                    columns_schema[dimx].push({name:sc,colspan:1,sortColumn:lcol})
                                }else{
                                    columns_schema[dimx].push({name:sc,colspan:1})
                                }
                            }
                            last_columns[dimx]=sc
                            dimx++;
                        })
                        
                        if(!columns.includes(lcol))
                            columns.push(c.join('|'))
                    })

                    sum_row    = x.sum
                    sum_column = x.sum_column
                }
            }else{
                
            }
        })
        .catch((e) => {
            console.log(e)
            loading    = false;
        })
    }
    function excel(){
        exportExcelReport({Project:""},{"name":executed})
    }
    function updateCell(val,field,field_type,table,id_field,id_value){
        fetch(apiUrl+"funcs",{
            method : "POST",
            body   : JSON.stringify({method:"updateSql",
                fields:[
                    {name:field,value:val,field_type:field_type},
                ],
                table:table,
                id_field:id_field,
                id_value:id_value,
            }),
            cors   : 'no-cors',
            credentials:'include',
        })
        .then(x=>x.json())
        .then(x=>{
            if(!x.result)alert("ошибка обновления значения")
        })
    }
    let multiplicator_shown=undefined;
</script>

<div style="height:calc(100% - 40px)">
    <div style="position:absolute;height:100%;width:300px;padding:2px;box-shadow: 0px 0px 2px grey;overflow:auto">
        {#each statistics as stat}
            <Card color="info">
                <CardHeader style="font-weight:bold;padding:4px;color:white">{stat.path}</CardHeader>
                <CardBody style="padding:2px;background-color:white">
                    {#each stat.items as item}
                        <Button block outline={statistic==item?false:true} color={statistic==item?"success":"info"} on:click={()=>{console.log(stat.path);statistic=item;path=stat.path}}>{item}</Button>
                    {/each}
                </CardBody>
            </Card>
        {/each}
    </div>
    <div style="position:absolute;left:300px;height:100%;width:calc(100% - 300px)">
        <div style="width:calc(100% - 140px);position:absolute;top:2px;left:1px;background-color:white;z-index:9999">
            <DefaultFilter bind:statistic bind:expanded={filterExpanded} on:change={(e)=>{filter=e.detail.filter}}/>
        </div>
        <Button style="position:absolute;right:100px;top:2px;padding:0px" outline color="dark" on:click={()=>{excel()}}>
            <img src="/img/excel-icon.png" alt="to-excel" style="width:35px;height:35px;"/>
        </Button>
        <Button style="position:absolute;right:2px;top:2px;" outline color="dark" on:click={()=>{execStat()}} disabled={!statistic}>Показать</Button>
        <div style="position:absolute;width:100%;top:50px;height:calc(100% - 62px);overflow:auto;padding:3px;" id="content">
            {#if loading}
                <img src="/img/load.gif" alt="loading..."/>
            {:else if statistic=="нагрузка суперов new"}
                <Table bordered style="width:auto" size="sm">
                    {#if columns}
                        <thead>
                            <tr>
                                {#each columns as column}
                                    <th style="cursor:pointer;background-color:rgb(202, 247, 255)" >
                                        {column}
                                    </th>
                                {/each}
                            </tr>
                        </thead>
                    {/if}
                    {#if data}
                         <tbody>
                            {#each data as row}
                                <tr style="background-color:rgb(147, 199, 136);cursor:pointer" on:click={()=>{multiplicator_shown=row}}>
                                    {#each columns as column}
                                        <td>{#if row.data[column]}{row.data[column]}{/if}</td>
                                    {/each}
                                </tr>
                                {#each row.children as child}
                                    <tr style={multiplicator_shown!=row?"display:none":""}>
                                        {#each columns as column}
                                            {#if child[column] == undefined}
                                                <td></td>
                                            {:else}
                                                <td>{typeof child[column] ==='number' ? (child[column]).toString().replace('.',',') : (child[column]).toString()}</td>
                                            {/if}
                                        {/each}
                                    </tr>
                                {/each}
                            {/each}
                        </tbody>
                    {/if}
                </Table>
            {:else}
                <Table bordered style="width:auto" size="sm">
                    {#if columns}
                        <thead>
                            {#each columns_schema as row}
                                <tr>
                                    {#each row as col}
                                        <th colspan={col.colspan} style={col.sortColumn?"cursor:pointer;background-color:rgb(202, 247, 255)":"background-color:rgb(202, 247, 255)"} on:click={()=>{if(col.sortColumn)sort(col.sortColumn)}}>
                                            {col.name}
                                        </th>
                                    {/each}
                                </tr>
                            {/each}
                        </thead>
                    {/if}
                    {#if data}
                        <tbody>
                            {#each data as row}
                                <tr>
                                    {#each columns as column}
                                        {#if column != sum_column}
                                            {#if row[column]==undefined }
                                                <td></td>
                                            {:else}
                                                {#if row[column].input}
                                                    <td style={row[column].bg_color?`background-color:${row[column].bg_color}`:""}>
                                                        <Input style="width:120px;" value={row[column].value} type={row[column].input.type=="number"?"number":(row[column].input.type=="bool"?"checkbox":(row[column].input.type=="date"?"datetime":"text"))} on:change={(e)=>{updateCell(e.target.value,row[column].input.field,row[column].input.type,row[column].input.table,row[column].input.id_field,row[column].input.id_value)}} />
                                                        {#if row[column].img}  <img style="width:18px;height:18px" src={row[column].img} alt="img" /> {/if}
                                                    </td>
                                                {:else}
                                                    {#if row[column].value == undefined}
                                                        <td></td>
                                                    {:else}
                                                        <td style={row[column].bg_color?`background-color:${row[column].bg_color}`:""}>{typeof row[column].value ==='number' ? (row[column].value).toString().replace('.',',') : (row[column].value).toString()}
                                                        {#if row[column].img}  <img style="width:18px;height:18px" src={row[column].img} alt="img" /> {/if}
                                                        </td>
                                                        
                                                    {/if}
                                                {/if}
                                            {/if}
                                        {/if}
                                    {/each}
                                    {#if sum_column}
                                        {#if row[sum_column]==undefined || row[sum_column].value == undefined}
                                            <td></td>
                                        {:else}
                                            <td style={row[sum_column].bg_color?`background-color:${row[sum_column].bg_color}`:"background-color:rgb(214, 214, 214)"}>{typeof row[sum_column].value ==='number' ? (row[sum_column].value).toString().replace('.',',') : (row[sum_column].value).toString()}</td>
                                        {/if}
                                    {/if}
                                </tr>
                            {/each}
                        </tbody>
                        {#if sum_row && sum_row!=null}
                            <tr style="font-weight:bold">
                                {#each columns as column}
                                    {#if sum_row[column] == undefined}
                                        <td></td>
                                    {:else}
                                        <td>{typeof sum_row[column] ==='number' ? (sum_row[column]).toString().replace('.',',') : (sum_row[column]).toString()}</td>
                                    {/if}
                                {/each}
                            </tr>
                        {/if}
                    {/if}
                    
                </Table>
            {/if}
        </div>
    </div>
</div>  